import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import ImportList from '../Parts/ImportList';
import ObjectOverride from "components/ObjectOverride";
import UniversalModalOverride from "components/UniversalModalOverride";

export default class UPCAddObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Upc_Center._name);

	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		if (this.state.search !== this.props.scannedCode) {
			this.setState({
				search: this.props.scannedCode
			}, this.shouldHandleScan);
		}
	}


	handleDataChange = event => {
		this.setState({[event.target.name]: event.target.value});
	};

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Products_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>

					<div className={"row"}>
						{/*#region Col 1*/}
						<div className={"col-md"}>
							{/*#region ATF Required Information*/}
							<h4 className="section-title">ATF Required Information</h4>
							<div className="form-group" data-id={'product-type'}>
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.type}
									value={object.type}
									error={object.type_error}
									model={Types.Products_Types._name}
									id={'name'}
									nullable={true}
									limit={null}
								/>
							</div>
							{
								((object.type === 'Rifle' || object.type === 'Rifle / Shotgun') && this.props.locations.some((location) => {
									let borderStates = ["AZ", "TX", "NV", "CA"]
									return borderStates.includes(location.state)
								})) &&
								<div style={{marginTop: '-10px', marginBottom: '1rem', textAlign: 'right'}}>
									<p style={{marginBottom: '2px', color: 'grey', fontStyle: 'italic', fontSize: '12px'}}>Semi-automatic rifle with a
										detachable magazine?</p>
									<Framework.Elements.ButtonSwitch
										property={properties.semi_auto_w_detach}
										value={object.semi_auto_w_detach}
										error={object.semi_auto_w_detach_error}
										update={this.handleTextFieldPropertyUpdate}
										labelTrue={'Yes'}
										labelFalse={'No'}
										nullable={true}
									/>
								</div>
							}
							<div className="form-group" data-id={'manufacturer'}>
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.manufacturer}
									value={object.manufacturer}
									error={object.manufacturer_error}
									object={object.manufacturers}
									nullable={true}
									default={{value: '', label: 'Other (Manual Entry)'}}
									defaultFirst={false}
								/>
							</div>
							{!object.manufacturer ?
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Manufacturer (Manual Entry)"}
										value={object.manufacturer_other}
										error={object.manufacturer_other_error}
										property={properties.manufacturer_other}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div> : null}
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Importer (If Imported)"}
									value={object.importer}
									error={object.importer_error}
									property={properties.importer}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Model"}
									value={object.model}
									error={object.model_error}
									property={properties.model}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group" data-id={'caliber'}>
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.caliber}
									value={object.caliber}
									error={object.caliber_error}
									object={object.calibers}
									nullable={true}
									default={{value: '', label: 'Other (Manual Entry)'}}
									defaultFirst={false}
								/>
							</div>
							{!object.caliber ?
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Caliber (Manual Entry)"}
										value={object.caliber_other}
										error={object.caliber_other_error}
										property={properties.caliber_other}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div> : null}

							{/*#endregion*/}
						</div>
						{/*#endregion*/}
						{/*#region Col 2*/}
						<div className={"col-md"}>
							{/*#region Details*/}
							<h4 className="section-title">Details</h4>
							<div className="form-group">
								<div className="row">
									<div className="col-6">
										<span className="input-label">New/Used Item</span>
									</div>
									<div className="col-6 text-right">
										<Framework.Elements.ButtonSwitch
											property={properties.used_firearm}
											value={object.used_firearm}
											error={object.used_firearm_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'Used'}
											labelFalse={'New'}
										/>

									</div>
								</div>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-md-12"}>
										<Framework.Elements.TextField
											label={"SKU or UPC"}
											value={object.sku}
											error={object.sku_error}
											property={properties.sku}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>

									{/*/ Todo: I don't think we need this because we are adding a new upc. */}
									{/*<div className={"col-md-3 text-right"}>*/}
									{/*	<Button*/}
									{/*		size={"md"}*/}
									{/*		color="green-meadow"*/}
									{/*		onClick={this.handleProductLookup}>*/}
									{/*		Lookup*/}
									{/*	</Button>*/}
									{/*</div>*/}
								</div>
							</div>
							<div className={"row"}>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Barrel Length"}
											value={object.barrel_length}
											error={object.barrel_length_error}
											property={properties.barrel_length}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Overall Length"}
											value={object.overall_length}
											error={object.overall_length_error}
											property={properties.overall_length}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*<div className="form-group" data-id={'item_description'}>*/}
							{/*	<Framework.Elements.TextField*/}
							{/*		label={"Bound Book Notes"}*/}
							{/*		value={object.item_description}*/}
							{/*		error={object.item_description_error}*/}
							{/*		property={properties.item_description}*/}
							{/*		update={this.handleTextFieldPropertyUpdate}*/}
							{/*		multiline={4}*/}
							{/*	/>*/}
							{/*</div>*/}
							<div className={"row"}>
								<div className={"col-md-4"}>
									<h4 className="section-title">Cost</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Cost"}
											value={object.cost}
											error={object.cost_error}
											property={properties.cost}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md-4"}>
									<h4 className="section-title">Min Price</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Min Price"}
											value={object.price_min}
											error={object.price_min_error}
											property={properties.price_min}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md-4"}>
									<h4 className="section-title">List Price</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"List Price"}
											value={object.price_list}
											error={object.price_list_error}
											property={properties.price_list}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*<div className="form-group">*/}
							{/*	<Framework.Elements.TextField*/}
							{/*		label={"Retail Label Notes"}*/}
							{/*		value={object.tag_note}*/}
							{/*		error={object.tag_note_error}*/}
							{/*		property={properties.tag_note}*/}
							{/*		update={this.handleTextFieldPropertyUpdate}*/}
							{/*	/>*/}
							{/*</div>*/}
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
						{/*#region Col 3*/}
						<div className={"col-md"}>
							<h4 className="section-title">Serial Number</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Serial Number"}
									value={object.serial_number}
									error={object.serial_number_error}
									property={properties.serial_number}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
					</div>

				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					name={"Import List of Serial Numbers"}
					object={ImportList}
					showModal={this.state.showImportListModal}
					handleToggle={this.handleImportListClick}
					afterSave={this.handleImportListChange}
					afterSubmit={() => {}}
				/>

			</div>
		)
	}
}
